/**
 * Mapa templateId -> `buildDocumentModel()` dos 5 templates Easy Solutions,
 * mesmo mapeamento usado por `../PageContent.js` para escolher qual
 * `PdfDocument` renderizar (ver esse arquivo).
 */
import { buildDocumentModel as fm200 } from '../manutencao-preventiva-fm200/sections/documentModel'
import { buildDocumentModel as sdai } from '../manutencao-preventiva-sdai/sections/documentModel'
import { buildDocumentModel as co2Resinas } from '../manutencao-preventiva-co2-resinas/sections/documentModel'
import { buildDocumentModel as co2Lnp } from '../manutencao-preventiva-co2-lnp/sections/documentModel'
import { buildDocumentModel as relatorioManutencaoSdai } from '../relatorio-manutencao-sdai/sections/documentModel'

const REGISTRY = {
  1: fm200,
  2: sdai,
  3: co2Resinas,
  4: co2Lnp,
  5: relatorioManutencaoSdai
}

export const getDocumentModelBuilder = templateId => REGISTRY[templateId]

export const buildDocumentModelForTemplate = (templateId, serviceOrder) => {
  const builder = getDocumentModelBuilder(templateId)
  return builder ? builder(serviceOrder) : null
}
